export default context => [
  { text: context.$t('label.acordo'), icon: 'dashboard', route: 'acordo', role: 'ACD_PAGINA' },
  { text: context.$t('label.dashboard'), icon: 'dashboard', route: 'dashboard', role: 'DASH_OPER' },
  { text: context.$t('label.dashboard_gerencial'), icon: 'dashboard', route: 'dashboard-gerencial', role: 'DASH_GER' },
  {
    text: context.$tc('label.cadastro', 2),
    icon: 'input',
    sub: [
      { text: context.$tc('label.alcada', 1), icon: 'monetization_on', route: 'alcada', role: 'ALCADA' },
      { text: context.$tc('label.cliente', 1), icon: 'people_outline', route: 'cliente', role: 'CLIENTE' },
      { text: context.$t('label.centro_custo'), icon: 'attach_money', route: 'centro-custo', role: 'CECO' },
      { text: context.$tc('label.estrutura_usuario', 1), icon: 'recent_actors', route: 'estrutura-usuario', role: 'ESTRUTURA' },
      { text: context.$tc('label.gestao_usuario', 1), icon: 'perm_identity', route: 'usuario', role: 'USR' },
      { text: context.$tc('label.perfil', 1), icon: 'group', route: 'sso-grupo', role: 'PERFIL' },
      { text: context.$tc('label.produto', 1), icon: 'shopping_basket', route: 'produto', role: 'PRD' },
      { text: context.$t('label.regiao'), icon: 'location_on', route: 'regiao', role: 'REGIAO' },
      { text: context.$t('label.sellin'), icon: 'payment', route: 'sellin', role: 'SELLIN' },
      { text: context.$tc('label.tipo_investimento', 1), icon: 'attach_money', route: 'tipo-investimento', role: 'TIPO_LINHA' },
      { text: context.$tc('label.tipo_acao', 1), icon: 'content_paste', route: 'tipo-acao', role: 'TIPO_ACAO' },
      { text: context.$t('label.tipo_orcamento'), icon: 'trending_up', route: 'tipo-orcamento', role: 'TIPO_ORC' },
      { text: context.$tc('label.unidade_medida', 1), icon: 'aspect_ratio', route: 'unidade-medida', role: 'UNID_MEDIDA' },
      { text: context.$t('label.workflow'), icon: 'group_work', route: 'workflow', role: ['FLUXO_PAGINA', 'FLUXO_CRUD'] },
      { text: context.$t('label.calendario'), icon: 'calendar_today', route: 'calendario', role: ['CONFIG_CALENDARIO'] },
    ],
  },
  {
    text: context.$tc('label.administracao', 1),
    icon: 'track_changes',
    sub: [
      { text: context.$tc('label.configuracao', 2), icon: 'settings', route: 'configuracao', role: 'CONFIG' },
      { text: context.$tc('label.suporte', 1), icon: 'build', route: 'administracao', role: 'ADMINISTRACAO' },
      { text: context.$tc('label.transferencia_posse', 2), icon: 'transfer_within_a_station', route: 'transferencia-posse', role: ['TRANS_POSSE_FUN', 'TRANS_POSSE_DIV'] },
      { text: context.$tc('label.termo_aceite', 1), icon: 'description', route: 'termo-aceite', role: 'TERMO_ACEITE' },
      { text: context.$tc('label.gestao_aprovacao', 1), icon: 'linear_scale', route: 'gestao-aprovacao', role: 'FLUXO_GEST_APRO' },
    ],
  },
  { text: context.$tc('label.apuracao', 1), icon: 'playlist_add_check', route: 'apuracao', role: ['APU_CRUD', 'APU_PAGINA'] },
  { text: context.$t('label.acordos_vencidos'), icon: 'alarm_off', route: 'apuracoes-vencidas', role: 'CANC_APU_CRUD' },
  { text: context.$tc('label.negociacao', 1), icon: 'content_paste', route: 'negociacao', role: 'NEG' },
  { text: context.$t('label.orcamento'), icon: 'find_in_page', route: 'orcamento', role: ['ORC_PAGINA', 'ORC_CRUD'] },
  { text: context.$tc('label.pagamento', 1), icon: 'payment', route: 'pagamento', role: 'PGTO' },
  { text: context.$tc('label.margemcontribuicao', 1), icon: 'track_changes', route: 'margem-contribuicao', role: ['MARGEM_ROI'] },
];



// WEBPACK FOOTER //
// ./src/custom/abbrasil/menu/menu.js